<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
      <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer" (click)="choose(item.id)">
        <span [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
      </li>
    </ul>
    
    <div *ngIf="now=='0'">
      <r-table [data]="posts_input">
        <ng-template let-post #operation_dk>
          <span *ngIf="post.key=='opt'">
            <a href="javascript:void(0)" title="點我設定"  (click)="edit_data=data[post.idx];get_show_data_arr(edit_data.type);subnow='0'" data-toggle="modal" data-target=".bd-example-modal-lg">
              <i style="margin-right:10px" class="fas fa-file-signature" ></i>
            </a>
            <a href="javascript:void(0)" *ngIf="data[post.idx].reward_open" title="排名" (click)="view_it(data[post.idx],0);subnow='1'" data-toggle="modal" data-target=".bd-example-modal-lg">
              <i style="margin-right:10px" class="fas fa-trophy"></i>
            </a>
            <a href="javascript:void(0)" *ngIf="!data[post.idx].reward_open" title="排名" style="color:grey">
              <i style="margin-right:10px" class="fas fa-trophy"></i>
            </a>
            <a href="{{link}}/statistics/{{data[post.idx].time_info}}" title="統計資訊">
              <i style="margin-right:10px" class="fas fa-chart-line"></i>
            </a>
          </span>
        </ng-template>
        <ng-template let-post #operation_mb>
          <span *ngIf="post.key=='opt'">
            <a href="javascript:void(0)" title="點我設定"  (click)="edit_data=data[post.idx];get_show_data_arr(edit_data.type);subnow='0'" data-toggle="modal" data-target=".bd-example-modal-lg">
              <i style="margin-right:10px" class="fas fa-file-signature" ></i>
            </a>
            <a href="javascript:void(0)" *ngIf="data[post.idx].reward_open" title="排名" (click)="view_it(data[post.idx],0);subnow='1'" data-toggle="modal" data-target=".bd-example-modal-lg">
              <i style="margin-right:10px" class="fas fa-trophy"></i>
            </a>
            <a href="javascript:void(0)" *ngIf="!data[post.idx].reward_open" title="排名"  style="color:grey">
              <i style="margin-right:10px" class="fas fa-trophy"></i>
            </a>
            <a href="{{link}}/statistics/{{data[post.idx].time_info}}" title="統計資訊">
              <i style="margin-right:10px" class="fas fa-chart-line"></i>
            </a>
          </span>       
        </ng-template>
        <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation> 

      </r-table>
    </div>
    <div *ngIf="now=='1' && edit_data">
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">活動名</label>
        <input type="text" class="form-control fix_input"  [(ngModel)]="edit_data.name" >
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">狀態</label>
        <button [ngClass]="edit_data.status==1?'btn-success':'btn-secondary'"  (click)="edit_data.status=1" class="btn" >上架</button>
        <button [ngClass]="edit_data.status==0?'btn-success':'btn-secondary'" (click)="edit_data.status=0" class="btn" >下架</button>
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">banner圖片</label>
        <span (click)="edit_data.pic='';tmp_banner_img_b64=undefined" style="cursor:pointer;">
        <img loading="lazy"  [src]="tmp_banner_img_b64?tmp_banner_img_b64:edit_data.pic" style="margin:0 5px 0 10px;width: 100px;display: inline;"></span>
      
        <div class="btn btn-info" style="position:relative;margin-left:10px;">
          <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event,1)"
          placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
        </div>
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">內文圖片</label>
        <span (click)="edit_data.pic='';tmp_content_img_b64=undefined" style="cursor:pointer;">
        <img loading="lazy"  [src]="tmp_content_img_b64?tmp_content_img_b64:edit_data.pic2" style="margin:0 5px 0 10px;width: 100px;display: inline;"></span>
      
        <div class="btn btn-info" style="position:relative;margin-left:10px;">
          <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event,2)"
          placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
        </div>
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">比賽規則</label>
        <div class="offset-sm-2">
          <span class="show_title" >開始時間:</span>
          <input type="datetime-local" class="form-control" style="width:160px" (ngModelChange)="edit_data.start_dt = $event"  [ngModel]="edit_data.start_dt | date:'yyyy-MM-ddTHH:mm'" />
          <span class="show_title" >結束時間:</span>
          <input type="datetime-local" class="form-control" style="width:160px" (ngModelChange)="edit_data.end_dt = $event"  [ngModel]="edit_data.end_dt | date:'yyyy-MM-ddTHH:mm'" />
        </div>
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">比賽類型</label>
        <button (click)="get_show_data_arr(1)"  [ngClass]="edit_data.type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">收益</button>
        <button (click)="get_show_data_arr(2)"  [ngClass]="edit_data.type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">消費</button>
        <button (click)="get_show_data_arr(3)"  [ngClass]="edit_data.type=='3'?'btn-success':'btn-secondary'"  class="btn  m5">儲值</button>
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">參加身分</label>
        <button (click)="ck_checkbox(1)"  [ngClass]="edit_data.identity_type.indexOf(1)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">一般</button>
        <button (click)="ck_checkbox(2)"  [ngClass]="edit_data.identity_type.indexOf(2)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">經紀</button>
        <button (click)="ck_checkbox(3)"  [ngClass]="edit_data.identity_type.indexOf(3)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">內部</button>
          
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">比賽規則</label>
        <button (click)="edit_data.count_type=1"  [ngClass]="edit_data.count_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">總鑽石數</button>
        <button (click)="edit_data.count_type=2"  [ngClass]="edit_data.count_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">總次數</button>
      </div>
      <div class="user_edit_block">
        <label class="col-sm-2 col-form-label">標的類型</label>
        <button (click)="target_type_adjust(0)"  [ngClass]="edit_data.only_diamond=='0'?'btn-success':'btn-secondary'"  class="btn  m5">背包物品</button>
        <button (click)="target_type_adjust(1)"  [ngClass]="edit_data.only_diamond=='1'?'btn-success':'btn-secondary'"  class="btn  m5">背包兼禮物</button>
        <button (click)="target_type_adjust(2)"  [ngClass]="edit_data.only_diamond=='2'?'btn-success':'btn-secondary'"  class="btn  m5">純鑽石</button>
      </div>
      <div class="user_edit_block" *ngIf="edit_data.only_diamond==2">
        <label class="col-sm-2 col-form-label">參賽項目</label>
        <select class="form-control"
        *ngIf="c_r_obj[edit_data.type]"
        style="width: 160px;display: inline-block;margin:10px"
        [(ngModel)]="race_obj.tmp"
        (change)="choose_race_item(race_obj.tmp);aft_ck_gift()"
        >
          <option selected="true" [ngValue]="'1'" disabled="true">請選擇</option>
          <option *ngFor="let item of c_r_obj[edit_data.type]" [ngValue]="item">{{item.name}}</option>
        </select>

        <div class="offset-sm-2">
          <button
          style="margin: 3px;"
          *ngFor="let item of edit_data.target_ids;let i = index"
          class="btn btn-success"
          (click)="edit_data.target_ids.splice(i,1);aft_ck_gift()"
          >
          {{show_data_arr[item]}}
          </button>
        </div>

        
      </div>
      <div class="user_edit_block" *ngIf="edit_data.target_ids &&( edit_data.target_ids.indexOf('-1')!=-1 || edit_data.target_ids.indexOf('-2')!=-1)">
        <label class="col-sm-2 col-form-label" >贈品類型</label>  
        <ul style="list-style: none;padding-left:0;margin-top: 10px;" class="offset-sm-2">
          <li *ngFor="let item of item_list;let i = index">
            <input type="checkbox"  
            [checked]="edit_data.item_config.indexOf(item.id) != -1"
            (change)="choose_detail_item(item,1)" 
            style="margin-right: 8px;">
            {{item.name}}
          </li>
        </ul>
        <hr>
      </div>
      <div class="user_edit_block" *ngIf="edit_data.target_ids.indexOf('10')!=-1||edit_data.target_ids.indexOf('-2')!=-1">
        <label class="col-sm-2 col-form-label" >禮物類型</label>
        <button *ngFor="let item of gift_list" 
        [ngClass]="choose_obj.now_g_tab==item.id*1?'btn-success':'btn-secondary'"  class="btn  m5"
        (click)="choose_detail_gift(item,0)">{{item.name}}</button>
      
        <ul style="list-style: none;padding-left:0;margin-top: 10px;" class="offset-sm-2">
          <div class="block_gift_option">
            <button class="btn btn-primary" (click)="choose_detail_gift(choose_obj.data,2)">全部勾選</button>
            <button class="btn btn-danger" (click)="choose_detail_gift(choose_obj.data,3)">全部取消</button>
          </div>
          <li *ngFor="let item of choose_obj.tmp_gift_list;let i = index">
         
            <input type="checkbox"  
            [checked]="edit_data.gift_config.indexOf(item.id) != -1"
            (change)="choose_detail_gift(item,1)" 
            style="margin-right: 8px;">
            {{item.name}}
          </li>
        </ul>
        <hr>
      </div>
      <div class="user_edit_block" *ngIf="race_obj">
        <label class="col-sm-2 col-form-label">獎項設定
          <div class="tips"></div>
        </label>
        名稱:<input class="form-control fix_input2" type="text" [(ngModel)]="race_obj.name" placeholder="名稱">
        名額:<input class="form-control fix_input2" type="number" [(ngModel)]="race_obj.num" placeholder="名額">
        分群等級:<input class="form-control fix_input2" type="number" [(ngModel)]="race_obj.rank" placeholder="等級">
        名次:<input class="form-control fix_input2" type="number" [(ngModel)]="race_obj.lv" placeholder="名次">
        鑽石數:<input class="form-control fix_input2" type="number" [(ngModel)]="race_obj.diamond" placeholder="鑽石數">
        <button (click)="add_reward()" style="display:inline" class="btn btn-primary">新增獎項</button>
        <hr>
        <label class="col-sm-2 col-form-label">獎池列表</label>
        <div  class="offset-sm-2" *ngFor="let item of edit_data.race_reward;let i = index">
      
          <div>
            <label class="col-sm-2 col-form-label">獎項名稱</label>
            <input  class="offset-sm-9" type="text" [(ngModel)]="item.name" class="form-control fix_input2">
          </div>
          <div>
            <label class="col-sm-2 col-form-label">數量</label>
            <input type="number" [(ngModel)]="item.num" class="form-control fix_input2">
          </div>
          <div>
            <label class="col-sm-2 col-form-label">分群等級</label>
            <input type="number" [(ngModel)]="item.rank" class="form-control fix_input2">
          </div>
          <div>
            <label class="col-sm-2 col-form-label">名次</label>
            <input type="number" [(ngModel)]="item.lv" class="form-control fix_input2">
          </div>
          <div>
            <label class="col-sm-2 col-form-label">鑽石數</label>
            <input type="number" [(ngModel)]="item.diamond" class="form-control fix_input2">
          </div>
       
         

          <button *ngIf="i!=0"  (click)="ch_arr_addr(i,-1)" class="btn btn-button btn_option">⬆</button>
          <button *ngIf="i!=edit_data.race_reward.length-1" (click)="ch_arr_addr(i,1)" class="btn btn-button btn_option">⬇</button>
          <button (click)="edit_data.race_reward.splice(i,1)" class="btn btn-danger">X</button>
        </div>
      </div>
      

      <button  style="margin-top:15px;" (click)="save(1)" class="btn btn-primary">新增活動</button>
    </div>
    <div 
    *ngIf="edit_data"
    class="modal fade bd-example-modal-lg" tabindex="-1"
     role="dialog"  data-keyboard="false" data-backdrop="static" 
     aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
    
     >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <label *ngIf="subnow=='0'" class="col-sm-2 col-form-label">設定</label>
            <label *ngIf="subnow=='1'" class="col-sm-2 col-form-label">排名</label>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
           <div class="modal-body" *ngIf="subnow=='1' && edit_data"> 
            <select class="form-control"
            style="width: 160px;display: inline-block;margin:10px"
            [(ngModel)]="ranklv"
            (change)="init_list()"
            >
            <option *ngFor="let item of rank_list" [ngValue]="item.id">{{item.name}}</option>
            </select>


              <table class="table table-responsive-sm" *ngIf="edit_data.length>0">
                <thead>
                  <tr class="table-primary" style="font-size:18px;">
                    <th style="width:5%">Rank</th>
                    <th style="width:5%">名次</th>
                    <th style="width:5%">姓名</th>
                    <th style="width:5%">大頭貼</th>
                    <th style="width:5%">性別</th>
       
                    <th style="width:5%">次數</th>
                    <th style="width:5%">鑽石數</th>
                    <th style="width:5%">獎品</th>
                    <th style="width:5%">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of edit_data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                    <td>{{item.user_rank_lv|number}}</td>
                    <td>{{item.rank|number}}</td>
                    <td>
                      <span *ngIf="item.name && item.name.length>0" >
                        <a target="_blank" href="{{link}}/useractive/{{item.uid}}">
                          <span class="user_identity_{{item.identity}}">{{item.name}}
                            <div *ngIf="item.v_name.length>0">({{item.v_name}})</div>
                          </span>
                        </a>
                      </span>
                      <span *ngIf="item.name && item.name.length==0" >未填寫</span>
                    </td>
                    <td><img loading="lazy" [src]="item.profile_pic" style="height: 60px;"></td>
                    <td>{{item.gender==1?'男':'女'}}</td>
                   
                    <td>{{item.race_count|number}}</td>
                    <td>{{item.sum_diamond|number}}</td>
                    <td>{{item.reward}}</td>
                    <td >
                      <button (click)="item.reward_status=0" *ngIf="item.reward.length>0" [ngClass]="item.reward_status==0?'btn-success':'btn-secondary'"  class="btn  m5">未處理</button>
                      <button (click)="item.reward_status=1"  *ngIf="item.reward.length>0"  [ngClass]="item.reward_status==1?'btn-success':'btn-secondary'"  class="btn  m5">已發放</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation> 
              <div *ngIf="edit_data.length==0">無資料</div>

           

          </div> 
          <div class="modal-body" *ngIf="subnow=='0'"> 
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">活動名</label>
              <input type="text" class="form-control fix_input"  [(ngModel)]="edit_data.name" >
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">狀態</label>
              <button [ngClass]="edit_data.status==1?'btn-success':'btn-secondary'"  (click)="edit_data.status=1" class="btn" >上架</button>
              <button [ngClass]="edit_data.status==0?'btn-success':'btn-secondary'" (click)="edit_data.status=0" class="btn" >下架</button>
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">banner圖片</label>
              <span (click)="edit_data.pic='';tmp_banner_img_b64=undefined" style="cursor:pointer;">
              <img loading="lazy"  [src]="tmp_banner_img_b64?tmp_banner_img_b64:edit_data.pic" style="margin:0 5px 0 10px;width: 100px;display: inline;"></span>
            
              <div class="btn btn-info" style="position:relative;margin-left:10px;">
                <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event,1)"
                placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
              </div>
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">內文圖片</label>
              <span (click)="edit_data.pic='';tmp_content_img_b64=undefined" style="cursor:pointer;">
              <img loading="lazy"  [src]="tmp_content_img_b64?tmp_content_img_b64:edit_data.pic2" style="margin:0 5px 0 10px;width: 100px;display: inline;"></span>
            
              <div class="btn btn-info" style="position:relative;margin-left:10px;">
                <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="upload($event,2)"
                placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
              </div>
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">比賽規則</label>
              <div class="offset-sm-2">
                <span class="show_title" >開始時間:</span>
                <input type="datetime-local" class="form-control" style="width:160px" (ngModelChange)="edit_data.start_dt = $event"  [ngModel]="edit_data.start_dt | date:'yyyy-MM-ddTHH:mm'" />
                <span class="show_title" >結束時間:</span>
                <input type="datetime-local" class="form-control" style="width:160px" (ngModelChange)="edit_data.end_dt = $event"  [ngModel]="edit_data.end_dt | date:'yyyy-MM-ddTHH:mm'" />
              </div>
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">比賽類型</label>
              <button (click)="get_show_data_arr(1)"  [ngClass]="edit_data.type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">收益</button>
              <button (click)="get_show_data_arr(2)"  [ngClass]="edit_data.type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">消費</button>
              <button (click)="get_show_data_arr(3)"  [ngClass]="edit_data.type=='3'?'btn-success':'btn-secondary'"  class="btn  m5">儲值</button>
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">參加身分</label>
              <button (click)="ck_checkbox(1)"  [ngClass]="edit_data.identity_type.indexOf(1)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">一般</button>
              <button (click)="ck_checkbox(2)"  [ngClass]="edit_data.identity_type.indexOf(2)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">經紀</button>
              <button (click)="ck_checkbox(3)"  [ngClass]="edit_data.identity_type.indexOf(3)!=-1?'btn-success':'btn-secondary'"  class="btn  m5">內部</button>
                
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">比賽規則</label>
              <button (click)="edit_data.count_type=1"  [ngClass]="edit_data.count_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">總鑽石數</button>
              <button (click)="edit_data.count_type=2"  [ngClass]="edit_data.count_type=='2'?'btn-success':'btn-secondary'"  class="btn  m5">總次數</button>
            </div>
            <div class="user_edit_block">
              <label class="col-sm-2 col-form-label">標的類型</label>
              <button (click)="target_type_adjust(0)"  [ngClass]="edit_data.only_diamond=='0'?'btn-success':'btn-secondary'"  class="btn  m5">背包物品</button>
              <button (click)="target_type_adjust(1)"  [ngClass]="edit_data.only_diamond=='1'?'btn-success':'btn-secondary'"  class="btn  m5">背包兼禮物</button>
              <button (click)="target_type_adjust(2)"  [ngClass]="edit_data.only_diamond=='2'?'btn-success':'btn-secondary'"  class="btn  m5">純鑽石</button>
            </div>
            
            <div class="user_edit_block" *ngIf="edit_data.only_diamond==2">
              <label class="col-sm-2 col-form-label">參賽項目</label>
              <select class="form-control"
              *ngIf="c_r_obj[edit_data.type]"
              style="width: 160px;display: inline-block;margin:10px"
              [(ngModel)]="race_obj.tmp"
              (change)="choose_race_item(race_obj.tmp);aft_ck_gift()"
              >
                <option selected="true" [ngValue]="'1'" disabled="true">請選擇</option>
                <option *ngFor="let item of c_r_obj[edit_data.type]" [ngValue]="item">{{item.name}}</option>
              </select>
              <div class="offset-sm-2">
                <button
                style="margin: 3px;"
                *ngFor="let item of edit_data.target_ids;let i = index"
                class="btn btn-success"
                (click)="edit_data.target_ids.splice(i,1);aft_ck_gift()"
                >
                {{show_data_arr[item]}}
                </button>
              </div>
            </div>
            <div class="user_edit_block" *ngIf="edit_data.target_ids &&( edit_data.target_ids.indexOf('-1')!=-1 || edit_data.target_ids.indexOf('-2')!=-1)">
              <label class="col-sm-2 col-form-label" >贈品類型</label>  
              <ul style="list-style: none;padding-left:0;margin-top: 10px;" class="offset-sm-2">
                <li *ngFor="let item of item_list;let i = index">
                  <input type="checkbox"  
                  [checked]="edit_data.item_config.indexOf(item.id) != -1"
                  (change)="choose_detail_item(item,1)" 
                  style="margin-right: 8px;">
                  {{item.name}}
                </li>
              </ul>
              <hr>
            </div>
            <div class="user_edit_block" *ngIf="edit_data.target_ids.indexOf('10')!=-1||edit_data.target_ids.indexOf('-2')!=-1">
              <label class="col-sm-2 col-form-label" >禮物類型</label>
              <button *ngFor="let item of gift_list" 
              [ngClass]="choose_obj.now_g_tab==item.id*1?'btn-success':'btn-secondary'"  class="btn  m5"
              (click)="choose_detail_gift(item,0)">{{item.name}}</button>
            
              <ul style="list-style: none;padding-left:0;margin-top: 10px;" class="offset-sm-2">
                <div class="block_gift_option">
                  <button class="btn btn-primary" (click)="choose_detail_gift(choose_obj.data,2)">全部勾選</button>
                  <button class="btn btn-danger" (click)="choose_detail_gift(choose_obj.data,3)">全部取消</button>
                </div>
                <li *ngFor="let item of choose_obj.tmp_gift_list;let i = index">
               
                  <input type="checkbox"  
                  [checked]="edit_data.gift_config.indexOf(item.id) != -1"
                  (change)="choose_detail_gift(item,1)" 
                  style="margin-right: 8px;">
                  {{item.name}}
                </li>
              </ul>
              <hr>
            </div>
            <div class="user_edit_block" *ngIf="race_obj">
              <label class="col-sm-2 col-form-label">獎項設定
                <div class="tips"></div>
              </label>
              <div class="col-form-label">
                <label class="col-sm-2 col-form-label">名稱:</label><input class="form-control  col-sm-10" type="text" [(ngModel)]="race_obj.name" placeholder="名稱">
                <label class="col-sm-2 col-form-label">名額:</label><input class="form-control  col-sm-10" type="number" [(ngModel)]="race_obj.num" placeholder="名額">
                <label class="col-sm-2 col-form-label"> 分群等級:</label><input class="form-control  col-sm-10" type="number" [(ngModel)]="race_obj.rank" placeholder="等級">
                <label class="col-sm-2 col-form-label">名次:</label><input class="form-control  col-sm-10" type="number" [(ngModel)]="race_obj.lv" placeholder="名次">
                  <label class="col-sm-2 col-form-label">鑽石數:</label><input class="form-control  col-sm-10" type="number" [(ngModel)]="race_obj.diamond" placeholder="鑽石數">
                <button (click)="add_reward()" style="display:inline" class="btn btn-primary">新增獎項</button>
              </div>
             
             
              <hr>
              <label class="col-sm-2 col-form-label">獎池列表</label>
              <div  class="offset-sm-2" *ngFor="let item of edit_data.race_reward;let i = index">
                <div>
                  <label class="col-sm-2 col-form-label">獎項名稱</label>
                  <input  class="offset-sm-9" type="text" [(ngModel)]="item.name" class="form-control fix_input2">
                </div>
                <div>
                  <label class="col-sm-2 col-form-label">數量</label>
                  <input  class="offset-sm-9" type="number" [(ngModel)]="item.num" class="form-control fix_input2">
                </div>
                <div>
                  <label class="col-sm-2 col-form-label">分群等級</label>
                  <input type="number" [(ngModel)]="item.rank" class="form-control fix_input2">
                </div>
                <div>
                  <label class="col-sm-2 col-form-label">名次</label>
                  <input type="number" [(ngModel)]="item.lv" class="form-control fix_input2">
                </div>
                <div>
                  <label class="col-sm-2 col-form-label">鑽石數</label>
                  <input type="number" [(ngModel)]="item.diamond" class="form-control fix_input2">
                </div>

               
               
                
      
                <button  (click)="ch_arr_addr(i,-1)" *ngIf="i!=0" class="btn btn-button btn_option">⬆</button>
                <button  (click)="ch_arr_addr(i,1)" *ngIf="i!=edit_data.race_reward.length-1" class="btn btn-button btn_option">⬇</button>
                <button (click)="edit_data.race_reward.splice(i,1)" class="btn btn-danger">X</button>
                <hr>
              </div>
            </div>
     
    
          </div>
    
          <div class="modal-footer">
              <button type="button"  *ngIf="subnow!='0'" (click)="save(2)"   class="btn btn-primary" data-dismiss="modal">確認</button>
              <button type="button"  *ngIf="subnow=='0'" (click)="save(0)"  class="btn btn-primary" data-dismiss="modal">確認</button>
              <button type="button"  *ngIf="subnow=='0'" (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
          </div>
          </div>
      </div>
    </div>
</div>